<template>
    <transition name="modal">
        <div id="modal_welcome" v-if="showModalWelcome">
            <div class="modal-content">
                <div style="">
                    <carousel :items="1" @changed="changed" @updated="updated" :autoHeight="true" :nav="false" :loop="false">
                        <div>
                            <img src="/static/img/assets/welcome/welcome_step1.png" style="max-width: 460px;margin: auto;margin-top: 15px;">
                            <div style="padding: 0px 25px;text-align: center">
                                <h3>ตั้งค่า Chatbot เบื้องต้น</h3>
                                <p>ที่แถบ Chatbot คุณสามารถตั้งค่าข้อความต้อนรับ (Welcome Message),การตอบข้อความอัตโนมัติทั้งข้อความอินบ๊อคและคอมเม้น (Conversation) และ ส่งข้อความแบบกลุ่ม(Broadcast)
ในส่วนของข้อความที่ตอบไม่ได้จะแสดงในหน้า Training ซึ่งสามารถสอนChatbotเพิ่มเติมได้</p>
                            </div>

                        </div>


                        <div>

                            <img src="/static/img/assets/welcome/welcome_step2.png" style="max-width: 460px;margin: auto;margin-top: 15px;">
                            <div style="padding: 0px 25px;text-align: center">
                                <h3>ดูสรุปข้อมูล Analytics</h3>
                                <p>ที่แถบ Analytics จะแสดงสรุปข้อมูลของผู้ใช้ที่สนทนากับบอทในแต่ละช่วงเวลา และ แสดงเป็นกราฟ นอกจากนี้ยังแบ่งกลุ่มการสนทนา ซึ่งจะแสดงในส่วนของ Intents 
คุณสามารถตรวจสอบได้ว่ามีผู้ใช้สนทนาเรื่องใดมากที่สุด หรือคำถามใดถูกถามมากที่สุด</p>
                            </div>
                        </div>

                        <div>
                            <img src="/static/img/assets/welcome/welcome_step3.png" style="max-width: 460px;margin: auto;margin-top: 15px;">
                            <div style="padding: 0px 25px;text-align: center">
                                <h3>ตั้งค่าอื่นๆ Setting</h3>
                                <p>ที่แถบ Setting คุณสามารถเปิด-ปิดบอท ได้ในเมนู Activate Bot และ ตั้งค่าอื่นๆ เช่น ค่าจัดส่งสินค้า หรือ ข้อมูลการโอนเงินที่จะแสดงให้ลูกค้าทราบ 
ในส่วนของ Billing จะแสดงจำนวนวันคงเหลือที่สามารถใช้งานChatbotได้</p>
                            </div>
                        </div>
                        
                        <div v-if="selectedBot && selectedBot.theme == 'ecommercebasic'">
                            <img src="/static/img/assets/welcome/welcome_step4.png" style="max-width: 460px;margin: auto;margin-top: 15px;">
                            <div style="padding: 0px 25px;text-align: center">
                                <h3>ตั้งค่า Shop Plugin</h3>
                                <p>ที่แถบ Shop Plugin เป็นส่วนเสริมที่คุณสามารถ อัพโหลดสินค้า และ ตั้งค่าสต๊อกสินค้า เพื่อแสดงให้ลูกค้าดูบนหน้าแชทได้ นอกจากนี้ยังมีสรุปการสั่งซื้อจากลูกค้า (Order Summary) แสดงสรุปข้อมูลอีกด้วย</p>
                            </div>
                        </div>

                        <div>
                            <img src="/static/img/assets/welcome/welcome_step5.png" style="max-width: 460px;margin: auto;margin-top: 15px;">
                            <div style="padding: 0px 25px;text-align: center">
                                <h3>ส่วนช่วยเหลือ Help</h3>
                                <template v-if="!$store.state.theme.hide_zwiz">
                                    <p>หากมีคำถามหรือข้อสงสัยสามารถกดปุ่ม Help ที่มุมบนขวา เพื่อ <a href="https://blog.zwiz.ai/getstarted-zwizai/" target="_blank" rel="noopener noreferrer">[อ่านวิธีใช้แบบละเอียด]</a> หรือ <a href="https://facebook.com/groups/zwizaigroup" target="_blank" rel="noopener noreferrer">[เข้ากลุ่ม ZWIZ.AI]</a> หากคุณมีข้อสงสัยอื่นๆที่ต้องการติดต่อเรา กรุณา Email มาที่ <a :href="'mailto:'+ $store.state.theme.email_contact">{{$store.state.theme.email_contact}}</a></p>
                                </template>
                                <template v-else>
                                    <p>หากมีคำถามหรือข้อสงสัยสามารถติดต่อเรา กรุณา Email มาที่ <a :href="'mailto:'+ $store.state.theme.email_contact">{{$store.state.theme.email_contact}}</a></p>
                                </template>
                            </div>
                        </div>


                    </carousel>
                    <div class="text-center" style="margin-top: 15px">
                        <a href="javascript:void(0);" @click="onClose">{{ showFinish ? 'เริ่มเลย' : 'ข้าม'}}</a>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import carousel from 'vue-owl-carousel'
import { mapGetters, mapMutations } from 'vuex'

    export default {
        components: { carousel },
        data: function(){
            return {
                showFinish: false
            }
        },
        computed: {
            ...mapGetters({
                showModalWelcome: 'showModalWelcome',
                selectedBot: 'selectedBot',
            })
        },
        mounted: function(){
            var vm = this
            document.addEventListener("keydown", (e) => {
                if (e.keyCode == 27) {
                    vm.showModal = false
                }
            });
        },
        methods: {
            changed: function(event){
                this.showFinish = event.item.index == (event.item.count - 1)
            },
            updated: function(){

            },
            onClose: function(){
                this.$store.dispatch('clearModalWelcome')
            }
        },
        watch: {
            showModal: function(){

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/ModalWelcome.vue